var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"mt-0",attrs:{"cols":"12","offset":"0"}},_vm._l((_vm.phasen),function(card){return _c('Card',{key:card.id,staticClass:"seminar-card",attrs:{"main":"","elements":card.content,"flat":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }